import { registerFeatureWithDescription } from "lib/features"
import { FEATURE_FLAG_PROMOTE_REGIME_ID } from "./feature-flag-promote-regime-id.mjs"

export const FEATURE_FLAG_PROMOTE_REGIME = registerFeatureWithDescription({
    numericalId: 3002,
    id: FEATURE_FLAG_PROMOTE_REGIME_ID,
    name: "Promote Scenario to Draft Regime",
    // Sold with the Optimiser product (FIQ-2279), so it is no longer internal only. The status
    // is a label on the Features screen; access itself comes from the product's demand list.
    readyForProduction: true,
    descriptionLines: [
        "Allows a committed scenario to be promoted into a new draft maintenance regime, applying its rules as schedule tailorings with justifications.",
    ],
})
